import { render, staticRenderFns } from "./KlarnaModal.vue?vue&type=template&id=b1a302a2&"
import script from "./KlarnaModal.vue?vue&type=script&lang=js&"
export * from "./KlarnaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports